/**
 * SOLOMON — GENERATED IMAGE (authed inline render; spec
 * docs/superpowers/specs/2026-08-26-image-generation-inline-design.md §3.4)
 *
 * <img src> carries no auth header, so bytes come via the FileCard idiom:
 * authFetch → blob → objectURL. Fetch-once per id: a module-level cache of
 * objectURL promises is the lifetime owner — entries are revoked ONLY on
 * bounded eviction, deliberately not on unmount, so streaming re-renders and
 * conversation switches reuse the same objectURL instead of refetching ~1MB
 * BYTEA rows (review finding, 2026-08-27).
 */
import { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';

const API_URL = import.meta.env.VITE_API_URL || '';
const cache = new Map(); // id → Promise<objectURL|null>
const CACHE_MAX = 40;

function fetchObjectUrl(authFetch, id) {
  if (!cache.has(id)) {
    if (cache.size >= CACHE_MAX) {
      const [oldest] = cache.keys();
      cache.get(oldest).then((u) => u && URL.revokeObjectURL(u)).catch(() => {});
      cache.delete(oldest);
    }
    cache.set(id, (async () => {
      const res = await authFetch(`${API_URL}/api/images/${id}`);
      if (!res.ok) return null;
      return URL.createObjectURL(await res.blob());
    })().catch(() => null));
  }
  return cache.get(id);
}

export default function GeneratedImage({ id }) {
  const { authFetch } = useAuth();
  const [url, setUrl] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let alive = true;
    fetchObjectUrl(authFetch, id).then((u) => {
      if (!alive) return;
      if (u) setUrl(u); else setFailed(true);
    });
    return () => { alive = false; };
  }, [authFetch, id]);

  if (failed) return <div className="message-visual-pending">Image unavailable</div>;
  if (!url) return <div className="message-visual-pending">Loading image…</div>;
  return <img src={url} alt="Generated image" loading="lazy" />;
}
